<div id="preloader" *ngIf="show">
</div>
<div id="status" *ngIf="show"><i class="fa fa-circle-o-notch fa-spin"></i></div>